import React from "react";
import {
  ToastContainer,
  Slide,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppAlert = () => {
  return (
    <ToastContainer
      style={{
        zIndex: 100000000,
        // boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
      }}
      position="top-right"
      //   autoClose={false}
      // autoClose={3000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      draggable
      // toastClassName="rounded-xl shadow-lg"
      pauseOnHover
      // icon={false}
      transition={Slide}
      toastStyle={{
        borderRadius: "12px",
      }}
    />
  );
};

export default AppAlert;
